module.exports = __webpack_public_path__ + "img/1500938293.f7b87644.jpg";